import { render, staticRenderFns } from "./DialButton.vue?vue&type=template&id=574fde7d&"
import script from "./DialButton.vue?vue&type=script&lang=js&"
export * from "./DialButton.vue?vue&type=script&lang=js&"
import style0 from "./DialButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports